var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        "content-transition": { name: "rb-modal" },
        "disable-backdrop": _vm.backdropDisabled,
        name: _vm.name,
      },
      on: {
        "before-open": _vm.onBeforeOpen,
        "before-close": _vm.onHandleClose,
      },
    },
    [
      _c("focus-trap", { attrs: { active: true } }, [
        _c(
          "div",
          {
            staticClass: "rb-modal-container",
            class: [_vm.modalClassContainer, _vm.modalClassTheme],
            attrs: { "data-element-id": _vm.dataElementId },
          },
          [
            !_vm.hideCloseIcon
              ? _c(
                  "button",
                  {
                    ref: "closeModal",
                    staticClass: "rb-modal-close",
                    attrs: {
                      "data-analytics_available_call": "0",
                      type: "button",
                    },
                    on: { click: _vm.onHandleClose },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "common__icon",
                        class:
                          "common__icon--close-bold" +
                          (!_vm.modalClassTheme ? "" : "-light"),
                      },
                      [_vm._v("close modal")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rb-modal-header" },
              [_vm._t("modal-header")],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rb-modal-content" },
              [_vm._t("modal-content")],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }